import "./index.css";
import { AudioEntry, MediaPlayer } from "./MediaPlayer";
import { songs } from "./songs";
const durations = [
  46, 52, 116, 7, 6, 5, 5, 22, 140, 57, 56, 48, 53, 70, 47, 71, 54, 43, 48, 42,
  44, 43, 50, 70, 101, 169, 160, 143, 194, 94, 77, 5, 74, 99, 73, 70, 4, 9, 127,
  121, 112, 134, 121, 122, 147, 114, 114, 155, 83, 136, 118, 137, 153, 166, 140,
  226, 15,
];

const prettifyName = (name: string) => {
  const indexOfSlash = name.indexOf(" - ");
  return name.slice(indexOfSlash + 3).replace(".mp3", "");
};
const audios: AudioEntry[] = songs.map((song, i) => ({
  name: prettifyName(song),
  filename: `/homm3/ost/${song}`,
  duration: durations[i] ?? 0,
}));

// const audioDurations = [] as number[];
// let loaded = 0;
// for (const audio of audios) {
//   const mp3 = new Audio(audio.filename);
//   mp3.addEventListener("loadedmetadata", () => {
//     loaded++;
//     audioDurations[audios.indexOf(audio)] = Math.floor(mp3.duration);

//     if (loaded == audios.length) {
//       console.log(JSON.stringify(audioDurations));
//     }
//   });
// }

export function App() {
  return (
    <div className="m-auto flex flex-col w-full  h-[100dvh] max-w-[100vw]">
      <MediaPlayer audios={audios} />
    </div>
  );
}

export default App;
